import React from 'react';
import { Chart } from 'primereact/chart';
import { Skeleton } from 'primereact/skeleton';
import styles from './RadarChart.module.scss';
import useTenantStore from '../../../../stores/TenantStore';

const CHART_OPTIONS = {
  elements: {
    line: {
      borderWidth: 0,
    },
  },
  scale: {
    max: 100,
    min: 0,
    stepSize: 25,
  },
  plugins: {
    legend: {
      display: false,
    },
    datalabels: {
      display: false,
    },
  },
};

interface IRadarChartProps {
  safetyScore: number;
  phoneUsageScore: number;
  accelerationScore: number;
  brakesScore: number;
  corneringScore: number;
  speedingScore: number;
  loading: boolean;
}

const RadarChart: React.FC<IRadarChartProps> = ({
  safetyScore,
  phoneUsageScore,
  accelerationScore,
  brakesScore,
  corneringScore,
  speedingScore,
  loading,
}) => {
  const { appColors } = useTenantStore();
  const chartData = React.useMemo(
    () => ({
      labels: [
        'Phone Usage',
        'Acceleration',
        'Brakes',
        'Cornering',
        'Speeding',
      ],
      datasets: [
        {
          label: 'Score',
          data: [
            phoneUsageScore,
            accelerationScore,
            brakesScore,
            corneringScore,
            speedingScore,
          ],
          fill: true,
          backgroundColor:
            appColors?.find((c) => c.type === 'P200')?.value != null
              ? `${appColors?.find((c) => c.type === 'P200')?.value}3C`
              : 'rgba(255, 99, 132, 0.2)',
          pointBackgroundColor:
            appColors?.find((c) => c.type === 'P400')?.value ??
            'rgb(255, 99, 132)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor:
            appColors?.find((c) => c.type === 'P400')?.value ??
            'rgb(255, 99, 132)',
        },
      ],
    }),
    [
      accelerationScore,
      brakesScore,
      corneringScore,
      appColors?.find((c) => c.type === 'P200')?.value,
      appColors?.find((c) => c.type === 'P400')?.value,
      phoneUsageScore,
      speedingScore,
    ],
  );

  return (
    <div className={styles.radarChartsWrapper}>
      <div className={styles.radarChartscontainer}>
        <span className={styles.safetyScore}>
          Safety Score:{' '}
          <span className={styles.safetyScoreValue}>
            {loading ? '' : safetyScore}
          </span>
        </span>

        {loading ? (
          <Skeleton width="40rem" height="40rem" className="my-[4rem]" />
        ) : (
          <Chart
            className={styles.chart}
            type="radar"
            data={chartData}
            options={CHART_OPTIONS}
          />
        )}
      </div>
    </div>
  );
};

export default RadarChart;
